import React from "react";
import BaseLayout from "@/layouts/BaseLayout";
import { Outlet, createRootRoute, useLocation } from "@tanstack/react-router";

export const RootRoute = createRootRoute({
  component: Root,
});

function Root() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  if (isLoginPage) {
    return <Outlet />;
  }

  return (
    <BaseLayout>
      <Outlet />
    </BaseLayout>
  );
}
